import { createApp } from 'vue';

import SettingsPage from './SettingsPage.vue';

let settingsPageMounted = false;

export function initSettingsPage() {
  const mountElement = document.getElementById('settingsRoot');

  if (!mountElement || settingsPageMounted) {
    return;
  }

  createApp(SettingsPage).mount(mountElement);
  settingsPageMounted = true;
}
